<script>
  import parseData from './data.js'
  import MainContainer from './components/MainContainer.svelte'
  import SizeLegend from './components/sizeLegend.svelte'
  import Legend from './components/Legend.svelte'

  const dataSrc = {
    scatter:
      'https://docs.google.com/spreadsheets/d/e/2PACX-1vQryGd7Joo5VaWwV36AKV_ymIjuG0RBZuqgtEsGJZeRJo6DjmhyLKn-ZfEK8vqE8IdAeSo3MiEq2Bu6/pub?output=csv',
  }

  const data = loadData()

  async function loadData() {
    let res = await parseData({
      src: dataSrc,
    })
    return res
  }

  const init = () => {
    resize(mq)
  }

  let selectedIndicator = 'income_level'

  let isMobile = false
  let mq = window.matchMedia('(max-width: 48em)')

  function resize(mediaQueryList) {
    if (mediaQueryList.matches) {
      isMobile = true
    } else {
      isMobile = false
    }
  }

  try {
    // Chrome & Firefox
    mq.addEventListener('change', (e) => {
      resize(e)
    })
  } catch (e1) {
    try {
      // Safari, because it doesn't support addEventListener...
      mq.addListener((e) => {
        resize(e)
      })
    } catch (e2) {
      console.error(e2)
    }
  }

  window.addEventListener('DOMContentLoaded', init)
</script>

<main class="interactive">
  <header class="interactive__header">
    <h1>Charting China’s Covid-19 Diplomacy</h1>
    <p>
      This interactive plots countries’ scores in both the Medical Diplomacy
      Index and Vaccine Diplomacy Index. Higher scores indicate greater Chinese
      influence through Covid-19 diplomacy. Bubbles are sized according to GDP.
      Hover over a bubble or search a country’s name to reveal details. Toggle
      between coloring bubbles based on geographic region or income level and
      use the filters to highlight various country groupings. Click <a
        href="https://chinapower.csis.org/data/chinapower-chinese-covid-19-diplomacy-index-ccdi/"
        alt="China Power covid19 diplomacy index"
        target="_blank"
        rel="nofollow">here</a
      > to access the data, methodology, and source information behind the indices.
    </p>
  </header>

  {#await data}
    <div class="loading-container">
      <div class="loading"></div>
    </div>
  {:then allData}
    <MainContainer
      allData="{allData}"
      isMobile="{isMobile}"
      bind:selectedIndicator
    />

    <div class="interactive__legend-container">
      <SizeLegend />
      <Legend selectedIndicator="{selectedIndicator}" />
    </div>

    <footer class="interactive__source">
      <a href="https://chinapower.csis.org" class="source-holder"
        ><img
          src="./images/cpp-logo-red.svg"
          target="_blank"
          alt="ChinaPower Project"
          title="ChinaPower Project"
          width="300"
          height="31"
        /></a
      >
    </footer>
  {:catch error}
    <p style="color: red">{error.message}</p>
  {/await}
</main>

<style type="text/scss" global>
  @import './scss/components/_utilities.scss';
  @import './scss/layout/_base.scss';
  @import './scss/layout/_layout.scss';
  @import './scss/components/_header.scss';
  @import './scss/components/_source.scss';
  @import './scss/components/_loading.scss';
</style>
